import React, { useContext, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import ObjectIconImg from "../ObjectIconImg";
import fetcher from "../../../../dataProvider";
import {
  Link,
  Box,
  Typography,
  Button,
  Slide,
  List,
  ListItem,
  Divider,
  Select,
  MenuItem,
  InputLabel,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import moment from "moment";
import useCountDown from "../../../../hooks/useCountDown";
import Image from "next/image";
import Modal from "@mui/material";

const useStyles = makeStyles((theme) => ({
  sideBarPageContainer: {
    position: "relative",
    display: "block",
    overflow: "auto",
    overflowX: "hidden",
    width: "0px",
    top: "0",
    transition: "0.3s",
    "&.active": {
      width: "350px",
      transition: "0.3s",
    },
    "@media(max-width:767px)": {
      "&.active": {
        width: "100%",
        transition: "0.3s",
      },
    },
  },
  modalSidebarContainer: {
    position: "absolute",
    top: "0",
    width: "100%",
    height: "100%",
    zIndex: "99",
    background: "#fff",
    borderLeft: "1px solid #DDDDDD",
    boxShadow: "0px 0px 10px #ccc",
  },
  threadHeader: {
    position: "relative",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    height: "57px",
    padding: "8px 15px",
    borderBottom: "1px solid #f2f2f2",
    "& h4": {
      fontSize: "16px",
      fontWeight: "600",
    },
  },
  optionIconList: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "120px",
    "& li": {
      padding: "0",
    },
  },
  threadBody: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    top: "0",
    bottom: "0",
    justifyContent: "space-between",
    "& label": {
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      marginBottom: "15px",
    },
    '& input[type="checkbox"]': {
      width: "20px",
      height: "20px",
      marginRight: "10px",
    },
    "& h1": {
      fontSize: "28px",
      fontWeight: "600",
      wordBreak: "break-word",
    },
    "& > p": {
      fontSize: "14px",
      fontWeight: "400",
      color: "#505050",
    },
    "& > b": {
      color: "#000",
      fontWeight: "500",
    },
    "& div:empty": {
      display: "none",
    },
  },
  EnterThreadName: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "45px",
    fontSize: "12px",
    padding: "0 20px",
    borderRadius: "12px",
    marginBottom: "30px",
    border: "1px solid #ced4da",
  },
  pollInput: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "45px",
    fontSize: "12px",
    padding: "0 20px",
    borderRadius: "12px",
    marginBottom: "10px",
    border: "1px solid #ced4da",
  },

  pollDuration: {
    position: "relative",
    display: "block",
    width: "50%",
    height: "45px",
    fontSize: "12px",
    padding: "0 20px",
    borderRadius: "12px",
    marginBottom: "10px",
    border: "1px solid #ced4da",
    marginTop: "5px",
  },
  contentEditor: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "49px",
    padding: "13px 55px",
    fontSize: "14px",
    borderRadius: "70px",
    background: "#F0F1F3",
    resize: "none",
    border: "none",
  },
  messageContainer: {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "0 15px",
    "& img": {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: "1",
    },
  },
  iconSmily: {
    left: "20px",
  },
  iconSend: {
    right: "20px",
  },
  addMoreLink: {
    position: "relative !important",
    display: "block",
    color: "#E14084 !important",
    textDecoration: "none",
    margin: "20px 0 !important",
    fontSize: "16px",
  },
  userReaction: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
    fontSize: "12px",
    color: "#0000008a",
    position: "relative",
    paddingLeft: "30px",
    marginLeft: "15px",
    "&::before": {
      width: "30px",
      content: "''",
      backgroundImage: "url('/images/community/reply-line.svg')",
      position: "absolute",
      height: "16px",
      left: "0px",
      top: "10px",
    },
  },
  btnPollSubmit: {
    position: "relative !important",
    display: "block !important",
    width: "225px",
    color: "#fff !important",
    background:
      "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    borderRadius: "8px",
    margin: "0 auto !important",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
    background:
      "-webkit-linear-gradient(90.78deg, #b237f6 3.91%, #e94177 96.03%)",
    "-webkitBackgroundClip": "text",
    "-webkitTextFillColor": "transparent",
    fontWeight: "600",
  },
  userImg: {
    height: "16px",
    width: "16px",
    borderRadius: "50%",
    position: "relative",
    overflow: "hidden",
  },
  threadMsgDate: {
    position: "relative",
    display: "block",
    textAlign: "center",
    "& span": {
      position: "relative",
      display: "inline-block",
      padding: "4px 20px",
      background: "#F1F1F1",
      borderRadius: "8px",
      textAlign: "center",
    },
  },
  userActionInfo: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
  },
  userInfo: {
    display: "flex",
    alignItems: "flex-start",
    columnGap: "10px",
  },
  userNameDT: {
    position: "relative",
    display: "block",
    wordBreak: "break-all",
  },
  userName: {
    fontSize: "12px !important",
    fontWeight: "700 !important",
    margin: "0 0 7px !important",
  },
  userDT: {
    fontSize: "12px !important",
    margin: "0 !important",
  },
  bodyContentScroll: {
    position: "relative",
    width: "100%",
    overflow: "auto",
    padding: "0 15px 15px",
  },
  polldivder: {
    marginTop: "10px !important",
    marginBottom: "20px !important",
    display: "block",
    color: "red",
    background: "rgba(192, 192, 192, 0.2)",
  },

  handleTitle: {
    width: "414px",
    height: "27px",
    flex: "none",
    order: "1",
    flexGrow: "0",
  },
  textTitle: {
    width: "29px",
    height: "17px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "17px",
    color: "#000000",
    opacity: "0.54",
  },
  pollTitle: {
    width: "25px",
    height: "17px",
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "17px",
    color: "#E14084",
  },
  pollImg: {
    left: "12.5%",
    right: "12.5%",
    top: "12.5%",
    bottom: "12.5%",
  },
  inputPollContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "end",
    overflow: "auto",
    overflowX: "hidden",
    background: "#fff",
    height: "100%",
    padding: "15px",
  },
  pollForm: {
    overflow: "auto",
    marginBottom: "20px",
    padding: "0 15px 0",
  },
  todayPoll: {
    position: "relative",
    display: "block",
    padding: "20px 0",
    borderRadius: "10px",
    "& h2": {
      fontSize: "20px",
      fontWeight: "600",
    },
    "& p": {
      fontSize: "14px",
      fontWeight: "600",
      // marginTop: "18px",
      marginBottom: "10px",
    },
    "@media(max-width:480px)": {
      maxWidth: "100%",
      margin: "0",
    },
  },

  pollOptions: {
    position: "relative",
    display: "block",
    padding: "0",
    "& li": {
      position: "relative",
      display: "block",
      width: "100%",
      padding: "9px 15px",
      background: "#fff",
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.23)",
      borderRadius: "12px",
      marginBottom: "12px",
      fontSize: "12px",
    },
  },
  pollIndicatorOptions: {
    position: "relative",
    display: "block",
    padding: "0",
    "& li": {
      position: "relative",
      display: "block",
      width: "100%",
      padding: "0",
      marginBottom: "20px",
      fontSize: "12px",
      "& > div span:nth-child(2)": {
        transition: "0.3s",
      },
      "&:hover > div span:nth-child(2)": {
        transition: "0.3s",
        transform: "scale(1.05)",
        fontWeight: "600",
      },
    },
  },
  optionContent: {
    position: "relative",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    marginBottom: "5px",
  },
  linearProgressBar: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "6px !important",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.23)",
  },
  pollAnswer: {
    position: "relative",
    display: "block",
    width: "100%",
    fontSize: "12px",
    fontWeight: "600",
    marginTop: "30px",
  },
  pollMusicOptions: {
    position: "relative",
    display: "block",
    padding: "0",
    "& li": {
      position: "relative",
      display: "block",
      width: "100%",
      padding: "0",
      "& label": {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: "9px 15px",
        background: "#fff",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.23)",
        borderRadius: "12px",
        overflow: "hidden",
        marginBottom: "12px",
        fontSize: "12px",
        "&:hover ": {
          background: "rgba(225, 64, 132, 0.1)",
        },
      },
      "& label div": {
        width: "100%",
      },
      "& label div img": {
        marginRight: "10px",
      },
      '& label input[type="radio"]': {
        "-webkit-appearance": "none",
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        background:
          "center/cover no-repeat url('/images/community/disable-check.svg')",
      },
      '& label input[type="radio"]:checked': {
        background:
          "center/cover no-repeat url('/images/community/enable-check.svg')",
      },
      '& label input[type="radio"]:checked::before': {
        content: '""',
        position: "absolute",
        left: "0",
        right: "0",
        top: "0",
        bottom: "0",
        background: "#f5e5eb",
        borderRadius: "12px",
        border: "1px solid #E14084",
        mixBlendMode: "darken",
      },
    },
  },
  tabContainer: {
    display: "flex",
    position: "relative",
    maxWidth: "600px",
    "& .Mui-selected": {
      color: "#e14084 !important",
    },
    "& .MuiTabs-flexContainer": {
      width: "100%",
      justifyContent: "space-between",
    },
  },
  tabContentBox: {
    display: "block",
    position: "relative",
    padding: "60px 15px",
    textAlign: "center",
  },
  tab: {
    color: "#fff",
    textTransform: "capitalize !important",
    flexDirection: "row !important",
    minHeight: "36px !important",
    "&:focus": {
      outline: "none",
    },
    "& img": {
      margin: "0 5px 0 0 !important",
      width: "16px",
      height: "16px",
    },
    "@media (max-width: 480px)": {
      maxWidth: "110px",
      fontSize: "16px",
    },
  },
  musicPlayer: {
    position: "relative",
    display: "block",
    width: "100%",
    height: "6px !important",
  },
  hitPredictorList: {
    position: "relative",
    display: "block",
    "& li": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px 15px",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      boxShadow:
        "0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802)",
      borderRadius: "10px",
      marginBottom: "8px",
      "& img": {
        width: "60px",
        height: "60px",
        maxWidth: "initial",
        borderRadius: "10px",
      },
      "& h4": {
        fontWeight: "600",
        fontSize: "16px",
        color: "rgba(0,0,0,0.9)",
      },
      "& p": {
        fontWeight: "400",
        fontSize: "14px",
        color: "rgba(0,0,0,0.9)",
      },
      "& a": {
        textDecoration: "none",
        color: "#B0B0B0",
        fontSize: "12px",
        color: "#E14084",
        "@media(max-width:480px)": {
          whiteSpace: "nowrap",
        },
      },
      "& strong": {
        position: "absolute",
        top: "5px",
        left: "5px",
        fontWeight: "700",
        fontSize: "20px",
        color: "#000",
        opacity: "0.2",
      },
    },
    "& li.active": {
      border: "1px solid #E14084",
      "& h4": {
        color: "#E14084",
      },
      "& strong": {
        opacity: "1",
      },
      "& a": {
        color: "#E14084",
      },
    },
  },
  playIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "25px !important",
    height: "25px !important",
  },
  playerContainer: {
    position: "relative",
    display: "flex",
    alignItems: "end",
    "& time": {
      fontSize: "10px",
      padding: "0 5px",
      whiteSpace: "nowrap",
      color: "#0F1E36",
      opacity: "0.5",
      position: "relative",
      top: "5px",
    },
    "& img": {
      width: "15px !important",
      height: "15px !important",
      borderRadius: "0 !important",
      marginRight: "5px",
    },
  },
  videoScreen: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: "99",
    width: "300px",
    height: "217px",
  },
  congratsMsg: {
    position: "relative",
    display: "block",
    padding: "10px 0",
    background: "rgba(84, 181, 187, 0.1)",
    border: "1px solid #4BAF55",
    borderRadius: "8px",
    color: "#48B16E",
    textAlign: "center",
  },
}));

const HitPredictor = ({
  message,
  setSelectedSong,
  playedSeconds,
  selectedSong = null,
  totalDuration = 0,
  isPlaying = false,
  pauseSong,
  playSong,
  setSongList,
  isMobile,
}) => {
  const [isPollEnded, setIsPollEnded] = useState(false);
  const [displayResult, setDisplayResult] = useState(false);
  const {
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = useCountDown(message?.predictorEndDate);
  //   const isPollEnded = hasPollEnded(message?.createdAt, message?.pollEndDate);
  const classes = useStyles();

  //
  const [selectedOption, setSelectedOption] = useState([]);

  const [musicIcon, setMusicIcon] = useState(false);
  //   const [countSong, setCountSong] =useState(1);

  const { mutate: sendResponseToPredictor } = useMutation(
    (data) =>
      fetcher.post(`/v1/message/${data.messageId}/predictor-response`, {
        optionId: data.optionId,
      }),
    {
      onSuccess: (response) => {
        // alert("Your response has been recorded");
        console.log("res", response);
      },
      onError: (error) => {
        console.log("could not respond", error);
      },
    }
  );

  useEffect(() => {
    if (message) {
      if (message?.predictorResponseOption) {
        setSelectedOption(
          message?.predictorResponseOption.map((item) => item?.optionId)
        );
      }
    }
  }, [message]);

  const BorderLinearProgress2 = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#E14084" : "#fff",
    },
  }));

  const addResponseToPredictor = (messageId, optionId) => {
    if (optionId) {
      let allreadyselectd = selectedOption?.filter((item) => item == optionId);
      if (allreadyselectd?.length > 0) {
        let allSelectd = [...selectedOption];
        const indexvalue = allSelectd.indexOf(optionId);
        if (indexvalue > -1) allSelectd.splice(indexvalue, 1);
        setSelectedOption(allSelectd);
        sendResponseToPredictor({ messageId, optionId });
      } else {
        setSelectedOption([...selectedOption, optionId]);
        sendResponseToPredictor({ messageId, optionId });
      }
    }
  };

  useEffect(() => {
    if (message) {
      setSongList(message?.predictorOptions);
      if (message?.predictorEndDate) {
        const today = new Date();
        const endsAt = new Date(message?.predictorEndDate);
        const todayInGmt = new Date(today.toUTCString());
        if (endsAt.getTime() - todayInGmt.getTime() < 0) {
          setIsPollEnded(true);
        } else {
          setIsPollEnded(false);
        }
      } else {
        setIsPollEnded(false);
      }

      // should display result
      if (message?.predictorResultDate) {
        const today = new Date();
        const endsAt = new Date(message?.predictorResultDate);
        const todayInGmt = new Date(today.toUTCString());

        if (endsAt.getTime() - todayInGmt.getTime() < 0) {
          setDisplayResult(true);
        } else {
          setDisplayResult(false);
        }
      } else {
        setDisplayResult(false);
      }
    }
  }, [message]);

  const getPlayPercentage = () => {
    if (totalDuration && playedSeconds) {
      let playedPercent = Math.floor((playedSeconds * 100) / totalDuration);

      return playedPercent;
    }
    return 0;
  };

  const getPlayedTimeInSeconds = (seconds) => {
    if (seconds < 60) {
      return "0:" + Math.floor(seconds).toString();
    } else {
      let timeInMinute = Math.floor(seconds / 60);
      let timeInSeconds = Math.floor(seconds % 60);
      if (timeInSeconds < 10)
        return timeInMinute.toString() + ":0" + timeInSeconds.toString();
      else return timeInMinute.toString() + ":" + timeInSeconds.toString();
    }
  };

  const getVotePercentage = (options, option) => {
    if (options.length && option) {
      const totalRespone = options.reduce(
        (sum, item) => (item?.responseCount ? sum + item?.responseCount : sum),
        0
      );
      if (totalRespone)
        return (
          ((option?.responseCount ? option?.responseCount : 0) / totalRespone) *
          100
        );
      else return 0;
    }
    return 0;
  };

  const isWinner = () => {
    if (message) {
      if (message?.predictorResponseOption) {
        let responseMatch = message.predictorOptions.filter(
          (item) =>
            item?.isCorrect && item?._id == message?.predictorResponseOption
        );
        if (responseMatch.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  return (
    <>
      <Box>
        <Box className={classes.todayPoll}>
          {!displayResult && (
            <Typography
              component="p"
              style={{
                fontSize: "16px",
                lineHeight: "18px",
                fontWeight: "normal",
                fontWeight: "500",
              }}
            >
              🏆 Winners will be announced on{" "}
              {moment(message?.predictorResultDate).format("DD MMMM")}
            </Typography>
          )}

          {displayResult && isWinner() && (
            <Typography
              component="span"
              className={classes.congratsMsg}
              style={{
                margin: "10px 0 30px,",
                fontSize: "16px",
                wordBreak: "break-word",
              }}
            >
              <Box
                component="img"
                src="/images/home/confetti.png"
                width="18px"
              />{" "}
              Congratulations! You are the winner
            </Typography>
          )}

          <Typography
            component="span"
            style={{ fontSize: "16px", wordBreak: "break-word" }}
          >
            {" "}
            {message?.text}{" "}
          </Typography>
          {/* <Typography style={{ marginBottom: "0px", marginTop: "10px" }} component="h1">
            <strong>Predict the Hit Punjabi song for July’22.</strong>
          </Typography> */}
          {!isPollEnded ? (
            <List className={classes.hitPredictorList}>
              {message?.predictorOptions?.map((item, key) => {
                return (
                  <>
                    <ListItem
                      key={key}
                      className={
                        selectedOption.indexOf(item?._id) != -1 ? "active" : ""
                      }
                    >
                      {/* <Typography component="strong">
                        {(key + 1).toString()}
                      </Typography> */}
                      <Box style={{ position: "relative" }}>
                        <Box
                          component="img"
                          width={"60px"}
                          height={"60px"}
                          src={`https://img.youtube.com/vi/${item?.youtubeId}/mqdefault.jpg`}
                        />

                        <Box
                          component="img"
                          src={
                            selectedSong?._id == item?._id && isPlaying
                              ? "/images/hitpredict/pause.svg"
                              : "/images/hitpredict/video.svg"
                          }
                          className={classes.playIcon}
                          sx={{
                            cursor: "pointer",
                            borderRadius: "0px !important",
                            background: "rgba(0,0,0,0.4)",
                          }}
                          onClick={() => {
                            if (selectedSong?._id == item?._id && isPlaying) {
                              pauseSong();
                            } else setSelectedSong(item);
                          }}
                        />
                      </Box>
                      <Box style={{ padding: "0 10px", width: "100%" }}>
                        <Typography
                          variant="h4"
                          style={{
                            fontSize: "16px !important",
                            wordBreak: "break-word",
                            color:
                              item?._id == selectedOption
                                ? "rgb(225, 64, 132,1)"
                                : "rgba(0, 0, 0, 0.9)",
                          }}
                        >
                          {item?.songName}
                        </Typography>
                        <Typography
                          component="p"
                          style={{ fontSize: "16px", wordBreak: "break-word" }}
                        >
                          {item?.singerName}
                        </Typography>

                        {selectedSong?._id == item?._id &&
                          item?.songType == "audio" && (
                            <Box className={classes.playerContainer}>
                              <Box
                                component="img"
                                src={
                                  isPlaying
                                    ? "/images/hitpredict/audio.gif"
                                    : "/images/musicPause.svg"
                                }
                                width="20px"
                                height="20px"
                              />
                              <BorderLinearProgress2
                                className={classes.musicPlayer}
                                variant="determinate"
                                value={getPlayPercentage()}
                              />
                              <time>
                                {getPlayedTimeInSeconds(playedSeconds)} / 3:33
                              </time>
                            </Box>
                          )}
                      </Box>

                      <Link
                        href="#"
                        // disabled={
                        //   !message?.hasResponedToPredictor && !selectedOption
                        // }
                        onClick={() => {
                          // if (
                          //   !message?.predictorResponseOption &&
                          //   !selectedOption
                          // ) {
                          //   addResponseToPredictor(message?._id, item?._id);
                          // } else {
                          //   alert(
                          //     "You have already voted. Wait for the results."
                          //   );
                          // }
                          // refreshMessages();
                          addResponseToPredictor(message?._id, item?._id);
                        }}
                        // sx={{
                        //   cursor: selectedOption
                        //     ? "default !important"
                        //     : "pointer !important",
                        //   color:
                        //     selectedOption && selectedOption != item?._id
                        //       ? "#B0B0B0 !important"
                        //       : "#E14084 !important",
                        // }}
                      >
                        {selectedOption.indexOf(item?._id) != -1
                          ? "Selected"
                          : "Select"}
                      </Link>
                    </ListItem>

                    {/* ==========List Item 3 Start=========== */}
                    {/* <ListItem>
                      <Typography component="strong">3</Typography>
                      <Box style={{position:"relative"}}>
                        <Box component="img" src="/images/hitpredict/song-thumb-3.png"/>
                        <Link href="#"><Box component="img" src="/images/hitpredict/video.svg" className={classes.playIcon}/></Link>
                      </Box>
                      <Box style={{padding:"0 10px",width:"100%"}}>
                        <Typography variant="h4">Tere Saath Hoon Main</Typography>
                        <Typography component="p">Himesh Reshammiya, Irshad K</Typography>
                      </Box>
                      <Link href="#">12%</Link>
                    </ListItem> */}
                    {/* ==========List Item 3 Start=========== */}

                    {/* ==========List Item 3 Start=========== */}
                    {/* <ListItem className="active">
                      <Typography component="strong">3</Typography>
                      <Box style={{position:"relative"}}>
                        <Box component="img" src="/images/hitpredict/song-thumb-3.png"/>
                        <Link href="#"><Box component="img" src="/images/hitpredict/video.svg" className={classes.playIcon}/></Link>
                      </Box>
                      <Box style={{padding:"0 10px",width:"100%"}}>
                        <Typography variant="h4">Tere Saath Hoon Main</Typography>
                        <Typography component="p">Himesh Reshammiya, Irshad K</Typography>
                      </Box>
                      <Box component="img" style={{padding:"5px"}} src="/images/hitpredict/stamp.svg"/>
                      <Link href="#">12%</Link>
                    </ListItem> */}
                    {/* ==========List Item 3 Start=========== */}

                    {/* <ListItem className="active">
                      <Typography component="strong">2</Typography>
                      <Box style={{position:"relative"}}>
                        <Box component="img" src="/images/hitpredict/song-thumb-2.png"/>
                        <Link href="#"><Box component="img" src="/images/hitpredict/pause.svg" className={classes.playIcon}/></Link>
                      </Box>
                      <Box style={{padding:"0 10px",width:"100%"}}>
                        <Typography variant="h4">Gawara Nahin</Typography>
                        <Typography component="p">Ankit Tiwari</Typography>
                        <Box className={classes.playerContainer}>
                          <Box component="img" src="/images/hitpredict/audio.gif" width="20px" height="20px" />
                          <BorderLinearProgress2 className={classes.musicPlayer} variant="determinate" value="50" />
                          <time>0.54 / 3:33</time>
                        </Box>
                      </Box>
                      <Link href="#">Selected</Link>
                    </ListItem>
                    
                    <ListItem>
                      <Typography component="strong">3</Typography>
                      <Box style={{position:"relative"}}>
                        <Box component="img" src="/images/hitpredict/song-thumb-3.png"/>
                        <Link href="#"><Box component="img" src="/images/hitpredict/video.svg" className={classes.playIcon}/></Link>
                      </Box>
                      <Box style={{padding:"0 10px",width:"100%"}}>
                        <Typography variant="h4">Tere Saath Hoon Main</Typography>
                        <Typography component="p">Himesh Reshammiya, Irshad K</Typography>
                      </Box>
                      <Box component="img" style={{padding:"5px"}} src="/images/hitpredict/stamp.svg"/>
                      <Link href="#">12%</Link>
                    </ListItem> */}
                  </>

                  // <ListItem key={key}>
                  //   <label
                  //     htmlFor="option1"
                  //     style={{
                  //       border:
                  //         message?.predictorResponseOption == item?._id
                  //           ? "1px solid #e14084"
                  //           : "0px",
                  //     }}
                  //   >
                  //     <Box
                  //       component="img"
                  //       sx={{
                  //         width: "50px",
                  //         height: "50px",
                  //         borderRadius: "10px",
                  //         justifyContent: "center",
                  //         alignItems: "center",
                  //       }}
                  //       onClick={() => {
                  //         setSelectedSong(item);
                  //       }}
                  //       src={item?.albumImageUrl}
                  //     ></Box>

                  //     <Box
                  //       className={classes.playIcons}
                  //       sx={{ marginLeft: "10px" }}
                  //     >
                  //       <Typography variant="span">{item?.songName}</Typography>
                  //       <br></br>
                  //       <Typography variant="span">
                  //         {item?.singerName}
                  //       </Typography>
                  //     </Box>

                  //     <Typography
                  //       sx={{
                  //         color:
                  //           message?.predictorResponseOption == item?._id
                  //             ? "#e14084"
                  //             : "#999",
                  //         fontSize: "10px !important",
                  //         fontWeight: "normal",
                  //         cursor:
                  //           !message?.hasResponedToPredictor && !selectedOption
                  //             ? "pointer"
                  //             : "default",
                  //       }}
                  //       disabled={
                  //         !message?.hasResponedToPredictor && !selectedOption
                  //       }
                  //       onClick={() => {
                  //         if (
                  //           !message?.predictorResponseOption &&
                  //           !selectedOption
                  //         ) {
                  //           addResponseToPredictor(message?._id, item?._id);
                  //         } else {
                  //           alert(
                  //             "Option already selected. Wait for the Poll results."
                  //           );
                  //         }
                  //       }}
                  //     >
                  //       {message?.predictorResponseOption == item?._id
                  //         ? "Selected"
                  //         : "Select"}
                  //     </Typography>
                  //   </label>
                  // </ListItem>
                );
              })}
            </List>
          ) : (
            <>
              <List className={classes.hitPredictorList}>
                {message?.predictorOptions?.map((item, key) => {
                  return (
                    <>
                      <ListItem
                        key={key}
                        // className={item?.responseCount == 1 ? "active" : ""}
                        className={
                          selectedOption.indexOf(item?._id) != -1
                            ? "active"
                            : ""
                        }
                      >
                        {/* <Typography component="strong">
                          {(key + 1).toString()}
                        </Typography> */}
                        <Box style={{ position: "relative" }}>
                          <Box
                            component="img"
                            src={`https://img.youtube.com/vi/${item?.youtubeId}/mqdefault.jpg`}
                          />

                          <Box
                            component="img"
                            src={
                              selectedSong?._id == item?._id && isPlaying
                                ? "/images/hitpredict/pause.svg"
                                : "/images/hitpredict/video.svg"
                            }
                            className={classes.playIcon}
                            sx={{
                              cursor: "pointer",
                              borderRadius: "0px !important",
                            }}
                            onClick={() => {
                              if (selectedSong?._id == item?._id && isPlaying) {
                                pauseSong();
                              } else setSelectedSong(item);
                            }}
                          />
                        </Box>
                        <Box style={{ padding: "0 10px", width: "100%" }}>
                          <Typography
                            variant="h4"
                            style={{
                              color: item?.isCorrect
                                ? "rgb(225, 64, 132,1)"
                                : "rgba(0, 0, 0, 0.9)",
                            }}
                          >
                            {item?.songName}
                          </Typography>
                          <Typography component="p">
                            {item?.singerName}
                          </Typography>

                          {selectedSong?._id == item?._id &&
                            item?.songType == "audio" && (
                              <Box className={classes.playerContainer}>
                                <Box
                                  component="img"
                                  src={
                                    isPlaying
                                      ? "/images/hitpredict/audio.gif"
                                      : "/images/musicPause.svg"
                                  }
                                  width="20px"
                                  height="20px"
                                />
                                <BorderLinearProgress2
                                  className={classes.musicPlayer}
                                  variant="determinate"
                                  value={getPlayPercentage()}
                                />
                                <time>
                                  {getPlayedTimeInSeconds(playedSeconds)} / 3:33
                                </time>
                              </Box>
                            )}
                        </Box>
                        {item?.isCorrect && (
                          <Box
                            component="img"
                            style={{ padding: "5px" }}
                            src="/images/hitpredict/stamp.svg"
                          />
                        )}
                        <Link
                          disabled={
                            !message?.hasResponedToPredictor && !selectedOption
                          }
                        >
                          <Typography
                            sx={{
                              fontSize: "14px !important",
                              lineHeight: "17px !important",
                              fontWeight: "600 !important",
                              color: item?.isCorrect
                                ? "#E14084 !important"
                                : "#000 !important",
                            }}
                          >
                            {getVotePercentage(
                              message?.predictorOptions,
                              item
                            ).toFixed(2)}
                            %
                          </Typography>
                        </Link>
                      </ListItem>

                      {/* ==========List Item 3 Start=========== */}
                      {/* <ListItem>
                      <Typography component="strong">3</Typography>
                      <Box style={{position:"relative"}}>
                        <Box component="img" src="/images/hitpredict/song-thumb-3.png"/>
                        <Link href="#"><Box component="img" src="/images/hitpredict/video.svg" className={classes.playIcon}/></Link>
                      </Box>
                      <Box style={{padding:"0 10px",width:"100%"}}>
                        <Typography variant="h4">Tere Saath Hoon Main</Typography>
                        <Typography component="p">Himesh Reshammiya, Irshad K</Typography>
                      </Box>
                      <Link href="#">12%</Link>
                    </ListItem> */}
                      {/* ==========List Item 3 Start=========== */}

                      {/* ==========List Item 3 Start=========== */}
                      {/* <ListItem className="active">
                      <Typography component="strong">3</Typography>
                      <Box style={{position:"relative"}}>
                        <Box component="img" src="/images/hitpredict/song-thumb-3.png"/>
                        <Link href="#"><Box component="img" src="/images/hitpredict/video.svg" className={classes.playIcon}/></Link>
                      </Box>
                      <Box style={{padding:"0 10px",width:"100%"}}>
                        <Typography variant="h4">Tere Saath Hoon Main</Typography>
                        <Typography component="p">Himesh Reshammiya, Irshad K</Typography>
                      </Box>
                      <Box component="img" style={{padding:"5px"}} src="/images/hitpredict/stamp.svg"/>
                      <Link href="#">12%</Link>
                    </ListItem> */}
                      {/* ==========List Item 3 Start=========== */}

                      {/* <ListItem className="active">
                      <Typography component="strong">2</Typography>
                      <Box style={{position:"relative"}}>
                        <Box component="img" src="/images/hitpredict/song-thumb-2.png"/>
                        <Link href="#"><Box component="img" src="/images/hitpredict/pause.svg" className={classes.playIcon}/></Link>
                      </Box>
                      <Box style={{padding:"0 10px",width:"100%"}}>
                        <Typography variant="h4">Gawara Nahin</Typography>
                        <Typography component="p">Ankit Tiwari</Typography>
                        <Box className={classes.playerContainer}>
                          <Box component="img" src="/images/hitpredict/audio.gif" width="20px" height="20px" />
                          <BorderLinearProgress2 className={classes.musicPlayer} variant="determinate" value="50" />
                          <time>0.54 / 3:33</time>
                        </Box>
                      </Box>
                      <Link href="#">Selected</Link>
                    </ListItem>
                    
                    <ListItem>
                      <Typography component="strong">3</Typography>
                      <Box style={{position:"relative"}}>
                        <Box component="img" src="/images/hitpredict/song-thumb-3.png"/>
                        <Link href="#"><Box component="img" src="/images/hitpredict/video.svg" className={classes.playIcon}/></Link>
                      </Box>
                      <Box style={{padding:"0 10px",width:"100%"}}>
                        <Typography variant="h4">Tere Saath Hoon Main</Typography>
                        <Typography component="p">Himesh Reshammiya, Irshad K</Typography>
                      </Box>
                      <Box component="img" style={{padding:"5px"}} src="/images/hitpredict/stamp.svg"/>
                      <Link href="#">12%</Link>
                    </ListItem> */}
                    </>

                    // <ListItem key={key}>
                    //   <label
                    //     htmlFor="option1"
                    //     style={{
                    //       border:
                    //         message?.predictorResponseOption == item?._id
                    //           ? "1px solid #e14084"
                    //           : "0px",
                    //     }}
                    //   >
                    //     <Box
                    //       component="img"
                    //       sx={{
                    //         width: "50px",
                    //         height: "50px",
                    //         borderRadius: "10px",
                    //         justifyContent: "center",
                    //         alignItems: "center",
                    //       }}
                    //       onClick={() => {
                    //         setSelectedSong(item);
                    //       }}
                    //       src={item?.albumImageUrl}
                    //     ></Box>

                    //     <Box
                    //       className={classes.playIcons}
                    //       sx={{ marginLeft: "10px" }}
                    //     >
                    //       <Typography variant="span">{item?.songName}</Typography>
                    //       <br></br>
                    //       <Typography variant="span">
                    //         {item?.singerName}
                    //       </Typography>
                    //     </Box>

                    //     <Typography
                    //       sx={{
                    //         color:
                    //           message?.predictorResponseOption == item?._id
                    //             ? "#e14084"
                    //             : "#999",
                    //         fontSize: "10px !important",
                    //         fontWeight: "normal",
                    //         cursor:
                    //           !message?.hasResponedToPredictor && !selectedOption
                    //             ? "pointer"
                    //             : "default",
                    //       }}
                    //       disabled={
                    //         !message?.hasResponedToPredictor && !selectedOption
                    //       }
                    //       onClick={() => {
                    //         if (
                    //           !message?.predictorResponseOption &&
                    //           !selectedOption
                    //         ) {
                    //           addResponseToPredictor(message?._id, item?._id);
                    //         } else {
                    //           alert(
                    //             "Option already selected. Wait for the Poll results."
                    //           );
                    //         }
                    //       }}
                    //     >
                    //       {message?.predictorResponseOption == item?._id
                    //         ? "Selected"
                    //         : "Select"}
                    //     </Typography>
                    //   </label>
                    // </ListItem>
                  );
                })}
              </List>
            </>
          )}

          {!isPollEnded && selectedOption ? (
            <>
              <Typography
                component="p"
                style={{
                  textAlign: "center",
                  lineHeight: "21px",
                  wordBreak: "break-word",
                  fontSize: "16px !important",
                }}
              >
                Thank you for the participation.
                <br />
                We will announce the winners soon. {isMobile && <br />}
                {/* <Link
                  href="#"
                  style={{
                    color: "#E14084",
                    textDecoration: "none",
                    fontSize: "16px !important",
                  }}
                  onClick={() => {
                    addResponseToPredictor(message?._id, selectedOption);
                  }}
                >
                  Change Choice
                </Link> */}
              </Typography>
            </>
          ) : (
            <></>
          )}
          {!isPollEnded && (
            <Box>
              <Box
                sx={{
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="p"
                  sx={{
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  {" "}
                  Predictor ends in{" "}
                </Typography>
              </Box>

              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      align="center"
                    >
                      <Typography variant="h5" sx={{ fontSize: "16px" }}>
                        {days}
                      </Typography>
                      <Typography component="x-small" sx={{ fontSize: "16px" }}>
                        Days
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      align="center"
                    >
                      <Typography variant="h5" sx={{ fontSize: "16px" }}>
                        {hours}
                      </Typography>
                      <Typography component="x-small" sx={{ fontSize: "16px" }}>
                        Hours
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      align="center"
                    >
                      <Typography variant="h5" sx={{ fontSize: "16px" }}>
                        {minutes}
                      </Typography>
                      <Typography component="x-small" sx={{ fontSize: "16px" }}>
                        Min
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#000",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      align="center"
                    >
                      <Typography variant="h5" sx={{ fontSize: "16px" }}>
                        {seconds}
                      </Typography>
                      <Typography component="x-small" sx={{ fontSize: "16px" }}>
                        Sec
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default HitPredictor;
